import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { useState } from 'react';
import { downloadTicketsAction } from 'src/redux/actions/ticketActions';
import { DownloadTicketsPayload } from 'src/apis/TicketAPI';

const DownloadTicketDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } = useSelector((state: Store) => {
    if (state.dialog[DIALOGS.downloadTicket]) {
      return state.dialog[DIALOGS.downloadTicket];
    }
    return { opened: false, payload: {} };
  });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const { eventId, ticketIds = [] } = payload ?? {};

  const [downloadTo, setDownloadTo] = useState(!ticketIds?.length ? 'all' : 'selected');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.downloadTicket }));
  };

  const handleOk = () => {
    const data = {} as DownloadTicketsPayload;
    if (downloadTo === 'all') {
      data.event_id = eventId;
    } else {
      data.ticket_ids = ticketIds.map(Number);
    }
    dispatch(downloadTicketsAction(data));
    dispatch(closeDialog({ dialog: DIALOGS.downloadTicket }));
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="download-ticket"
      open={opened}>
      <DialogTitle id="download-ticket">{t(lang, 'forms.tickets.download_title')}</DialogTitle>
      <DialogContent dividers>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">{t(lang, 'forms.tickets.download_to')}</FormLabel>
          <RadioGroup
            row
            aria-label="download-to"
            name="download-to"
            value={downloadTo}
            onChange={(e) => setDownloadTo(e.target.value)}>
            <FormControlLabel value="all" control={<Radio />} label={t(lang, 'forms.tickets.all')} />
            <FormControlLabel
              value="selected"
              control={<Radio />}
              label={`${t(lang, 'forms.tickets.selected')} (${ticketIds?.length ?? 0})`}
              disabled={!ticketIds?.length} />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.cancel')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadTicketDialog;
